<fieldset>
   <legend class="h1">Services</legend>

  <fieldset class="d-flex flex-row gap-3">
     <app-form-field label="Pilot approval"
                     class="operational-status"
                     [renderOptional]="false"
                     [includeMargin]="false">
       <app-select class="mb-3"
                   [formControl]="$any(form.control.get('services').get('pilotApproval'))"
                   [options]="pilotApprovalOptions"
                   [formatterTemplate]="rt"
                   [required]="true">
         <div class="invalid-feedback">Pilot approval is required</div>
       </app-select>
     </app-form-field>
    </fieldset>
    <fieldset class="d-flex flex-row gap-3">
        <app-form-field label="Pilot">
            <app-radio [formControl]="$any(form.control.get('services').get('pilot'))"
                     [inline]="true"
                     [options]="booleanOptions"
                     [formatter]="booleanFormatter"
                     [required]="true">
            </app-radio>
        </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="Tugboat">
        <app-radio [formControl]="$any(form.control.get('services').get('tugboat'))"
                   [inline]="true"
                   [options]="booleanOptions"
                   [formatter]="booleanFormatter"
                   [required]="true">
        </app-radio>
        @if (servicesValues()?.tugboat) {
          <fieldset class="card mt-2 w-auto d-inline-block">
            <div class="card-body p-4 pb-2 pt-3">
              <div class="row">
                <div class="col-md-6">
                  <app-form-field label="Tugboat organisation">
                    <app-search
                      [formControl]="$any(form.control.get('services').get('tugboatOrganisation'))"
                      [options]="tugboatOrganizationsResource.value()"
                      [required]="true"
                      [placeholder]="'Type to search'">
                    </app-search>
                  </app-form-field>
                </div>
                <div class="col-md-3">
                  <app-form-field label="Number">
                    <app-search
                      [formControl]="$any(form.control.get('services').get('numberOfTugboats'))"
                      [options]="numberOfTugboatOptions"
                      [required]="true">
                    </app-search>
                  </app-form-field>
                </div>
              </div>
            </div>
          </fieldset>
        }
      </app-form-field>
    </fieldset>

    <fieldset class="d-flex flex-row gap-3">
      <app-form-field class="field-width" label="Boatmen">
        <app-radio [formControl]="$any(form.control.get('services').get('boatmen'))"
                   [inline]="true"
                   [options]="booleanOptions"
                   [formatter]="booleanFormatter"
                   [required]="true">
        </app-radio>
        @if (servicesValues()?.boatmen) {
          <fieldset class="card mt-2 w-auto d-inline-block">
            <div class="card-body p-4 pb-2 pt-3">
              <app-form-field class="field-width" label="Boatmen organisation">
                <!-- TODO: check whether these hardcoded options are also fine for Amsterdam and not just Rotterdam -->
                <app-search
                  class="mt-2"
                  [formControl]="$any(form.control.get('services').get('boatmenOrganisation'))"
                  [options]="['Van Kuijk', 'KRVE']"
                  [required]="true"
                  [placeholder]="'Type to search'">
                </app-search>
              </app-form-field>
            </div>
          </fieldset>
        }
      </app-form-field>
    </fieldset>
</fieldset>
<ng-template #rt let-status="result">
  @if (status) {
    <app-task-message-status [messageStatus]="status" [showTooltip]="false" />
  } @else {
    empty
  }
</ng-template>
